// extracted by mini-css-extract-plugin
export default {"container":"UserPage_container__QPugl","searchbar_container":"UserPage_searchbar_container__Hg5J+","searchbar_container_inner":"UserPage_searchbar_container_inner__AZK2H"};